/* aminos-beauty-review-tabs.js
 * Loaded only by sections/aminos-beauty-review-tabs.liquid.
 *
 * The markup renders every review, so the section is complete without this
 * file. This hides all but the first data-initial cards and wires the
 * "Load more" button to reveal data-step more per click. Focus moves to the
 * first newly shown card so keyboard and screen-reader users land on it.
 */
(function () {
  function init(root) {
    if (!root || root.dataset.btyReviewsReady === 'true') return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bty-reviews-card]'));
    var button = root.querySelector('[data-bty-reviews-more]');
    var list = root.querySelector('[data-bty-reviews-list]');
    var initial = parseInt(root.dataset.initial, 10) || 5;
    var step = parseInt(root.dataset.step, 10) || 5;
    if (!button || cards.length <= initial) return;
    root.dataset.btyReviewsReady = 'true';

    var shown = initial;

    cards.forEach(function (card, i) {
      card.hidden = i >= shown;
    });

    function update() {
      var done = shown >= cards.length;
      // The fade over the last visible card hints that more are below.
      if (list) list.classList.toggle('is-collapsed', !done);
      if (done) {
        button.parentNode.removeChild(button);
        return;
      }
      button.hidden = false;
    }

    button.addEventListener('click', function () {
      var first = cards[shown];
      var end = Math.min(shown + step, cards.length);
      for (var i = shown; i < end; i++) cards[i].hidden = false;
      shown = end;
      update();
      if (first) first.focus({ preventScroll: true });
    });

    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-bty-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
